import React from "react";
import SuccessPage from "./shared/SuccessPage";

const SubmitAgreements = () => {
  return (
    <SuccessPage title="You're all set">
      Your account migration is confirmed. We'll notify you once everything is
      complete.
    </SuccessPage>
  );
};

export default SubmitAgreements;
